import(/* webpackMode: "eager" */ "/codebuild/output/src1981340334/src/Sagio-front/src/app/[policy]/page.js");
